import { extendTailwindMerge } from "tailwind-merge";
import clsx, { type ClassValue } from "clsx";

export const isFunction = (value: unknown): value is (...args: any) => any =>
  typeof value === "function";

export const isNullOrUndefined = <T>(value: T): value is undefined | null =>
  value === null || value === undefined;

export function generateRandomColor(opacity = 1) {
  // 确保透明度在 0 到 1 之间
  if (opacity < 0 || opacity > 1) {
    opacity = 1;
  }

  // 生成随机的 RGB 值（0 到 255）
  const red = Math.floor(Math.random() * 256);
  const green = Math.floor(Math.random() * 256);
  const blue = Math.floor(Math.random() * 256);

  // 返回 RGBA 格式的颜色字符串
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}

const wbucTwMerge = extendTailwindMerge({ prefix: "wbuc-" });

export function cn(...inputs: ClassValue[]) {
  return wbucTwMerge(clsx(inputs));
}

// 阿拉伯数字转中文数字
export function arabicToChinese(num: number): string {
  if (num < 0) {
    return "负" + arabicToChinese(-num);
  }

  const chineseDigits = [
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
  ];
  const chineseUnits = [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
  ];

  let result = "";

  if (num === 0) {
    return "零";
  }

  const numStr = num.toString();
  const length = numStr.length;

  for (let i = 0; i < length; i++) {
    const digit = parseInt(numStr[length - i - 1]);
    const unitIndex = length - i - 1;

    if (digit !== 0) {
      result = chineseDigits[digit] + chineseUnits[unitIndex] + result;
    } else if (result.length > 0 && result[0] !== "零") {
      result = "零" + result;
    }
  }

  // 处理特殊情况：如“10”应为“十”，而不是“一十”
  result = result.replace(/一十/g, "十");

  return result;
}
